/**
 * Returns the MUI focus-trap root for `anchor`, or null if the anchor is not
 * inside an MUI modal/drawer/dialog.
 *
 * MUI Modal renders `<div class="MuiModal-root">` and wraps its content in a
 * FocusTrap whose root is the immediate child of that div. Drawer and Dialog
 * are both `styled(Modal, ...)`, so they share the same DOM shape. Rendering a
 * popper into this element keeps focus inside the trap, so the modal does not
 * yank focus out of inputs the user types into (e.g. a dropdown search box).
 */
export function findFocusTrapContainer(
  anchor: HTMLElement | null,
): HTMLElement | null {
  if (!anchor) {
    return null;
  }
  const modalRoot = anchor.closest(".MuiModal-root");
  if (!modalRoot) {
    return null;
  }
  let cursor: HTMLElement = anchor;
  while (cursor.parentElement && cursor.parentElement !== modalRoot) {
    cursor = cursor.parentElement;
  }
  if (cursor.parentElement !== modalRoot) {
    return null;
  }
  return cursor;
}
